import { render, staticRenderFns } from "./TermsPage.vue?vue&type=template&id=299df8f5&"
import script from "./TermsPage.vue?vue&type=script&lang=js&"
export * from "./TermsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports